import React, { useEffect } from 'react';
import { useLatest } from 'react-use';
import { createActor, fromPromise } from 'xstate';

import { useNamedLogger } from '@eluve/logger';

import { periodicLocalFileScanMachine } from './periodicLocalFileScan.machine';
import { AppointmentFilesTableDependency, GetFileReferences } from './types';

export interface PeriodicFileSyncMachineProviderProps {
  appointmentFilesTable: AppointmentFilesTableDependency;
  getFileReferences: () => Promise<GetFileReferences>;
}

export const PeriodicLocalFileScanMachineProvider: React.FC<
  PeriodicFileSyncMachineProviderProps
> = ({ appointmentFilesTable, getFileReferences }) => {
  const logger = useNamedLogger('PeriodicLocalFileScanMachineProvider');

  const latestAppointmentFilesTable = useLatest(appointmentFilesTable);
  const latestGetFileReferences = useLatest(getFileReferences);

  useEffect(() => {
    const machineActor = createActor(
      periodicLocalFileScanMachine.provide({
        actors: {
          getFiles: fromPromise<GetFileReferences>(
            latestGetFileReferences.current,
          ),
        },
      }),
      {
        input: {
          appointmentFilesTable: latestAppointmentFilesTable.current,
          logger,
          checkForFileDriftIntervalMs: 1000 * 20,
        },
      },
    );

    machineActor.start();

    return () => {
      logger.info('Stopping periodicFileSyncMachine');
      machineActor.stop();
    };
  }, [latestAppointmentFilesTable, latestGetFileReferences, logger]);

  return null;
};
